import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CustomButton from "../../../../shared/ui/CustomButton";
import Icon from "../../../../shared/ui/Icon";
import React from "react";

interface SuccessViewProps {
    message: string;
    onReset: () => void;
}

const SuccessView = ({message, onReset} : SuccessViewProps) => (
    <Box width="100%">
        <Typography mb={2}>{message}</Typography>
        <CustomButton
            buttonType="textIcon"
            onClick={onReset}
            icon={<Icon icon="fas plus" fixedWidth={true} />}
        >
            Generează teste
        </CustomButton>
    </Box>
);

export default SuccessView;